import { Action } from '@ngrx/store';
import { Consent } from '../model/consent.model';

/**
 * Actions related to consent disabling - does not require authorization:
 *
 * POST to initiate change request
 */

// initial POST
export const DISABLE_CONSENT_REQUEST = '[Disable Consent] Request';
export const DISABLE_CONSENT_SUCCESS = '[Disable Consent] Success';
export const DISABLE_CONSENT_ERROR =   '[Disable Consent] Error';

/**
 * Request to enable consent.
 */
export class DisableConsentRequestAction implements Action {
    readonly type = DISABLE_CONSENT_REQUEST;
}

/**
 * Request enable success action.
 * MEP authorization follows.
 */
export class DisableConsentSuccessAction implements Action {
    readonly type = DISABLE_CONSENT_SUCCESS;

    constructor(public payload: Consent) {}
}

/**
 * Request enable error action.
 */
export class DisableConsentErrorAction implements Action {
    readonly type = DISABLE_CONSENT_ERROR;

    constructor(public payload: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = DisableConsentRequestAction
    | DisableConsentSuccessAction
    | DisableConsentErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/actions/disable-consent.actions.ts